import ProductVatConfigForm from '@/pages/product-vat-config/ProductVatConfigForm';
import { domesticVatConfigScreen } from '@/pages/product-vat-config/productVatConfigScreenConfig';

interface DomesticVatConfigFormProps {
  mode: 'create' | 'edit';
}

const DomesticVatConfigForm = ({ mode }: DomesticVatConfigFormProps) => {
  return (
    <ProductVatConfigForm mode={mode} screenConfig={domesticVatConfigScreen} />
  );
};

export default DomesticVatConfigForm;
